import './RangeSlider.css';

type Props = {
    min?: number;
    max: number;
    value: number;
    onChange: (value: number) => void;
    ariaLabel: string;
};

export function RangeSlider({ min = 0, max, value, onChange, ariaLabel }: Props) {
    return (
        <input
            className="rangeSlider"
            type="range"
            min={min}
            max={max}
            step={max <= 1 ? 0.01 : 1}
            value={value}
            onChange={(e) => onChange(Number(e.target.value))}
            aria-label={ariaLabel}
        />
    );
}
